/** @module Enums */ /** typedoc */

export enum FileSelectionSourceEnum {
    Browse = 'Browse',
    DragAndDrop = 'DragAndDrop',
    BounceFolder = 'BounceFolder',
    VideoBounceFolder = 'VideoBounceFolder',
    Library = 'Library',
}
